<p-toast />
<p-confirmdialog />
<div class="absolute inset-0 flex w-full min-w-0 flex-auto flex-col">
  <div
    class="flex-0 flex flex-col border-b bg-white p-6 sm:flex-row sm:items-center sm:justify-between sm:p-10 dark:bg-transparent"
  >
    <div class="min-w-0 flex-1">
      <!-- Proposta 1 -->
      <div class="mx-auto flex w-full max-w-screen-lg flex-col gap-2">
        <div
          class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-0"
        >
          <div class="flex flex-row items-center gap-4">
            <div class="flex flex-col gap-2">
              <div
                class="text-primary-500 flex items-center gap-3 hover:cursor-pointer"
                (click)="goBack()"
              >
                <i class="pi pi-arrow-left text-base"></i>
                <span class="hover:underline">Indietro</span>
              </div>
              <h2
                class="truncate text-4xl font-bold leading-7 tracking-tight sm:leading-10 md:text-5xl"
              >
                {{ builderService.tenderFormInfo()?.title }}
              </h2>
            </div>
          </div>
          <div class="flex flex-row gap-2">
            <p-button
              label="Salva bozza"
              (click)="saveModule()"
              class="min-w-30"
              fluid
            ></p-button>
            @if (builderService.tenderFormId()) {
              <p-button
                label="Pubblica"
                severity="contrast"
                class="min-w-30"
                fluid
                (click)="publishModule()"
              ></p-button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <lib-builder-dashboard
    class="relative flex h-full w-full flex-1 overflow-hidden"
  />
</div>
